import React, {ReactElement, useEffect, useState} from 'react';
import Typography from "@mui/material/Typography";
import {Box, Button, Checkbox, CircularProgress, Paper, Table, TableBody, TableHead} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import {StyledTableCell, StyledTableRow} from "../common/table/TableStyles";
import TableLoadingMockup from "../common/table/TableLoadingMockup";
import {useGetOneDoctorsQuery, useSaveDoctorsRecordingDurationMutation} from "../../store/rtk-api/doctor/doctor";
import IsError from "../common/IsError";
import {useAppDispatch, useTypedSelector} from "../../store";
import {clearProcedures, setProcedures} from "../../store/procedure/procedure.slice";
import {clearSpecialities, setSpecialities} from "../../store/specialities/specialities.slice";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {useFormik} from "formik";
import CustomSelect from "../common/CustomSelect";
import {record_minutes} from "../common/helper";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CustomAlert from "../common/CustomAlert";

const mapping = {
    'spec': 'Специальность',
    'price': 'Цена',
    'kid': 'Детский',
    'action': 'Детская скидка',
    'empty': '',
    'empty1': '',
    'btn': 'Действие',
}

const mapping2 = {
    'spec': 'Процедуры',
    'price': 'Цена',
    'kid': 'Детский',
    'action': 'Детская скидка',
    'empty': '',
    'empty1': '',
    'btn': 'Действие',
}

interface IDoctorPostedActions {
    isActive: boolean | undefined,
    appointmentDuration: string,
    // recordingCapacity: string
}

const DoctorEdit = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const {state} = useLocation()
    const {addressId} = useTypedSelector(state => state.header)
    const [alertOpen, setAlertOpen] = useState(false)
    // @ts-ignore
    let doctorId = state.doctorId
    const {data: doctor, isLoading, isError} = useGetOneDoctorsQuery({doctorId, addressId}, {
        skip: !doctorId && addressId === null,
    })
    const [
        saveDoctorRecording,
        {isLoading: saveLoading, isError: saveError, isSuccess: saveSuccess}
    ] = useSaveDoctorsRecordingDurationMutation()
    const handleAddSpecialities = (doctor: number,) => {
        navigate('speciality')
        dispatch(setSpecialities({doctor}))
        dispatch(clearSpecialities())
    }

    const handleAddProcedures = (doctor: number,) => {
        navigate('procedure')
        dispatch(setProcedures({doctor}))
        dispatch(clearProcedures())
    }

    const handleGoToSpecialities = (
        id: number,
        price: string,
        discount: number,
        for_child: boolean | null,
        child_price: string,
        child_discount: number,
        doctor: number,
        speciality: {
            id: number,
            name: string
        },
        child_age_from: string,
        child_age_to: string,
        is_active:boolean,
        address:number
    ) => {
        navigate('speciality')
        dispatch(setSpecialities({
            id,
            price,
            discount,
            for_child,
            child_discount,
            child_price,
            doctor,
            speciality,
            child_age_from,
            child_age_to,
            is_active,
            address
        }))
    }
    const handleGoToProcedures = (
        id: number,
        // doctorId:number,
        price: string,
        discount: number,
        for_child: boolean | null,
        child_price: string,
        child_discount: number,
        doctor: number,
        procedures: {
            id: number,
            name: string
        },
        child_age_from: string,
        child_age_to: string,
        is_active:boolean,
        address:number,

    ) => {
        navigate('procedure')
        dispatch(setProcedures({
            id,
            price,
            discount,
            for_child,
            child_discount,
            child_price,
            doctor,
            procedures,
            child_age_from,
            child_age_to,
            is_active,
            address
        }))

    }

    useEffect(() => {
        if (saveSuccess || saveError) {
            setAlertOpen(true)
            setTimeout(() => {
                setAlertOpen(false)
            }, 2000)
        }
    }, [saveSuccess, saveError])

    // isPosted block actions
    const formik = useFormik<IDoctorPostedActions>({
        enableReinitialize: true,
        initialValues: {
            isActive: doctor?.doctor_address[0]?.is_active === false ? false : true,
            appointmentDuration: doctor?.doctor_address[0].duration || '30',
            // recordingCapacity: '',
        },
        onSubmit: (values) => {
            let active: 1 | 0 = 1;

            if (!values.isActive) active = 0
            // alert(JSON.stringify({...values,active},null,2))
            saveDoctorRecording({
                doctorId,
                addressId,
                duration: values.appointmentDuration,
                is_active: active,
            })
        }
    })
    const {handleChange, values, handleSubmit, setFieldValue} = formik

    const handleCheckBoxChange = () => {
        setFieldValue('isActive', !values.isActive)
    }

    return (
        <Box sx={{p: "20px 200px"}}>
            <IsError isError={isError}/>
            {saveSuccess && alertOpen &&
                <CustomAlert message={"Данные успешно сохранены!"} status={"success"}/>}
            {saveError && alertOpen && <CustomAlert message={"Произошла ошибка"} status={"error"}/>}

            {saveLoading && <CircularProgress/>}
            <Box sx={{maxWidth: "100%", maxHeight: "100%", p: "30px"}} component={Paper}>
                <Box sx={{display: "flex", gap: "15px"}}>
                    <div>
                        <img src={`http://api.docfinder.kz/${doctor?.photo}`} alt=""
                             style={{width: "100px", height: "120px", borderRadius: "50px"}}/>
                    </div>
                    <div>
                        <Typography sx={{
                            fontSize: "25px",
                            color: "#000"
                        }}>{`${doctor?.last_name} ${doctor?.first_name} ${doctor?.middle_name}`}</Typography>
                        <Box sx={{
                            fontSize: "18px",
                            color: "text.secondary",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                        }}>
                            {doctor?.doctor_specialities.map((spec, ind) => {
                                return <span key={spec.id}>{spec?.speciality?.name}</span>
                            })}
                        </Box>
                        <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                            <Typography sx={{fontSize: "18px"}}>Стаж: {doctor?.experience_years}</Typography> /
                            <Typography sx={{fontSize: "18px"}}>Плата за
                                консультацию: {doctor?.consultation_fee}</Typography>
                        </div>
                        <div style={{marginTop: "20px", fontSize: "18px"}}>
                            <HelperComponent
                                text={"Опубликован"}
                                title={"Чтобы отключить профиль этого врача, отмените публикацию каждой его специальности в списке ниже."}
                                children={<Checkbox checked={values.isActive} onChange={handleCheckBoxChange}/>}
                            />
                            <HelperComponent
                                text={"Длительность приема (в минутах)"}
                                title={"Это количество минут, которое вы выделяете на консультацию одного пациента."}
                                children={<CustomSelect
                                    handleChange={handleChange}
                                    value={values.appointmentDuration}
                                    name={'appointmentDuration'}
                                    items={record_minutes}
                                    width={"100px"}
                                />}
                            />
                            {/*<HelperComponent*/}
                            {/*    text={"Возможность записи (в минутах)"}*/}
                            {/*    title={"Это время в минутах, позже которого пациент не сможет записаться на прием. Пример: нельзя записаться за 5 минут до приема."}*/}
                            {/*    children={<CustomInput*/}
                            {/*        formik={formik}*/}
                            {/*        handleChange={handleChange}*/}
                            {/*        field={'recordingCapacity'}*/}
                            {/*        values={values}*/}
                            {/*        width={"100px"}*/}
                            {/*        type={"number"}*/}
                            {/*        size={"small"}/>}*/}
                            {/*/>*/}

                        </div>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "40px"
                        }}>
                            <Button variant={'contained'} onClick={() => navigate(-1)}>Назад к списку</Button>
                            <Button variant={'contained'} onClick={() => handleSubmit()}>Сохранить</Button>
                        </div>
                    </div>
                </Box>
            </Box>
            <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: "20px"}}>
                {/*// @ts-ignore*/}
                <Button onClick={() => handleAddSpecialities(state?.doctorId)}>Добавить специальность</Button>
            </div>
            <div>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            {Object.values(mapping).map((title, idx) => {
                                return (
                                    <StyledTableCell key={idx} align={"left"}>{title}</StyledTableCell>
                                )
                            })}
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ?
                            <TableLoadingMockup cellCount={6} rowCount={6}/>
                            :
                            doctor?.doctor_specialities?.map((item, ind) => (
                                <StyledTableRow key={item.id}>
                                    <StyledTableCell>{`${item?.speciality?.name}`}</StyledTableCell>
                                    <StyledTableCell>{item?.price}</StyledTableCell>
                                    <StyledTableCell>{item?.child_price}</StyledTableCell>
                                    <StyledTableCell>{item?.child_discount}</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell>
                                        <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                                            <Button
                                                onClick={() => handleGoToSpecialities(item?.id, item?.price, item?.discount, item?.for_child, item?.child_price, item?.child_discount, item?.doctor, item?.speciality, item?.child_age_from, item?.child_age_to,item?.is_active, item?.address)}
                                            >Редактировать
                                            </Button>
                                            {item?.is_active ? <CheckCircleIcon color={"success"}/> :
                                                <CancelIcon color={"error"}/>}
                                        </div>

                                    </StyledTableCell>
                                    <StyledTableCell>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        }

                    </TableBody>
                </Table>
            </div>
            <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: "20px"}}>
                {/*// @ts-ignore*/}
                <Button onClick={() => handleAddProcedures(state?.doctorId)}>Добавить процедуру</Button>
            </div>
            <div>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            {Object.values(mapping2).map((title, idx) => {
                                return (
                                    <StyledTableCell key={idx} align={"left"}>{title}</StyledTableCell>
                                )
                            })}
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ?
                            <TableLoadingMockup cellCount={6} rowCount={5}/>
                            :
                            doctor?.doctor_procedures?.map((item, ind) => (
                                <StyledTableRow key={item.id}>
                                    <StyledTableCell>{`${item?.procedure?.name}`}</StyledTableCell>
                                    <StyledTableCell>{item?.price}</StyledTableCell>
                                    <StyledTableCell>{item?.child_price}</StyledTableCell>
                                    <StyledTableCell>{item?.child_discount}</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell>
                                        <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                                            <Button
                                                onClick={() => handleGoToProcedures(item?.id, item?.price, item?.discount, item?.for_child, item?.child_price, item?.child_discount, item?.doctor, item?.procedure, item?.child_age_from, item?.child_age_to,item?.is_active, item?.address)}
                                            >Редактировать
                                            </Button>
                                            {item?.is_active ? <CheckCircleIcon color={"success"}/> :
                                                <CancelIcon color={"error"}/>}
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        }

                    </TableBody>
                </Table>
            </div>

        </Box>

    );
};

export default DoctorEdit;

interface Props2 {
    text: string,
    title?: string,
    children: ReactElement
}

const HelperComponent: React.FC<Props2> = ({text, title, children}) => {
    return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px", gap:"10px"}}>
            <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                {text} <HelpOutlineIcon titleAccess={title} sx={{color: "primary.main"}}/>
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}